import * as XLSX from "xlsx";
import dayjs from "dayjs";

export function exportMatrixToExcel({
  entities,
  days,
  map,
  entityLabel,
  fileName,
}) {
  if (!entities.length) return;

  const sheetData = entities.map((name) => {
    const row = { [entityLabel]: name };
    days.forEach((d) => {
      const label = dayjs(d).format("DD/MM/YYYY");
      const val = map[name]?.[d];
      row[label] = val != null && val !== 0 ? Number(val) : "";
    });
    return row;
  });

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(sheetData), "Datos");
  XLSX.writeFile(wb, fileName);
}
